import { motion } from "framer-motion";
import {
  Snowflake,
  Wifi,
  Tv,
  ShowerHead,
  Car,
  Clock3,
  ConciergeBell,
  Shirt,
} from "lucide-react";

const ITEMS = [
  { icon: Snowflake, title: "AC in Every Room", text: "Chilled, quiet rooms with cove lighting and ceiling fans." },
  { icon: Wifi, title: "Free Wi-Fi", text: "High-speed internet access throughout the property." },
  { icon: Tv, title: "LED TV", text: "Satellite channels in all rooms for relaxed evenings." },
  { icon: ShowerHead, title: "24×7 Hot Water", text: "Round-the-clock hot water with power backup." },
  { icon: Car, title: "Safe Parking", text: "Spacious on-site forecourt for cars and coaches." },
  { icon: Clock3, title: "24×7 Front Desk", text: "Late arrivals welcome — check in any hour." },
  { icon: ConciergeBell, title: "Travel Assistance", text: "Temple taxis, darshan timing and route planning." },
  { icon: Shirt, title: "Laundry & Iron", text: "Fresh linen daily; laundry and pressing on request." },
];

export default function Amenities() {
  return (
    <section id="amenities" className="bg-cream-surface px-4 py-20 sm:px-8 lg:px-16 lg:py-28">
      <div className="mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="text-center"
        >
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-maroon-accent">
            Guest Comforts · <span className="font-kannada normal-case tracking-normal">ಸೌಕರ್ಯಗಳು</span>
          </p>
          <h2 className="mx-auto mt-3 max-w-2xl font-display text-3xl font-semibold tracking-tight text-forest-deep sm:text-4xl lg:text-4xl">
            Everything a traveller needs, <span className="italic text-gold">nothing they don't</span>
          </h2>
        </motion.div>

        <div className="mt-12 grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-forest/15 bg-forest/15 lg:grid-cols-4">
          {ITEMS.map((item, i) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`amenity-${item.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="group bg-cream p-6 transition-colors duration-500 hover:bg-forest sm:p-8"
            >
              <item.icon className="h-6 w-6 text-gold transition-transform duration-500 group-hover:-translate-y-1" />
              <h3 className="mt-4 font-display text-lg font-semibold text-forest-deep transition-colors duration-500 group-hover:text-amber-50">
                {item.title}
              </h3>
              <p className="mt-2 text-xs leading-relaxed text-stone-600 transition-colors duration-500 group-hover:text-amber-100/75">
                {item.text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
